import React, {
  createContext,
  useContext,
  useEffect,
  useState,
  useMemo,
} from 'react';
import { supabase } from './supabaseClient';

const AuthCtx = createContext(null);
export const useAuth = () => useContext(AuthCtx);

export function AuthProvider({ children }) {
  const [session, setSession] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    supabase.auth.getSession().then(({ data }) => {
      setSession(data.session || null);
      setLoading(false);
    });
    const { data: sub } = supabase.auth.onAuthStateChange((_event, sess) => {
      setSession(sess);
    });
    return () => sub.subscription.unsubscribe();
  }, []);

  const signInWithGoogle = async () => {
    await supabase.auth.signInWithOAuth({
      provider: 'google',
      options: {
        redirectTo: window.location.origin + '/dashboard',
        queryParams: { prompt: 'consent', access_type: 'offline' },
      },
    });
  };

  const signOut = async () => {
    await supabase.auth.signOut();
  };

  const rawUser = session?.user ?? null;

  const currentUser = useMemo(() => {
    if (!rawUser) return null;
    return {
      uid: rawUser.id,
      id: rawUser.id,
      displayName:
        rawUser.user_metadata?.full_name ||
        rawUser.user_metadata?.name ||
        rawUser.email,
      email: rawUser.email,
      photoURL:
        rawUser.user_metadata?.avatar_url ||
        rawUser.user_metadata?.picture ||
        null,
      raw: rawUser,
    };
  }, [rawUser]);

  return (
    <AuthCtx.Provider
      value={{ session, currentUser, loading, signInWithGoogle, signOut }}
    >
      {children}
    </AuthCtx.Provider>
  );
}
